module.exports = __webpack_public_path__ + "img/Explo-IT.6b8b5004.svg";